export default "__VITE_ASSET__BWKDL3LI__"